import "./index.less";
import { BASEURL } from "../../api/api.js";
// import "./js/jq-slideVerify.js";

new Vue({
  el: "#apply",
  data: function () {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    return {
      formInline: {
        name: "",
        mobile: "",
        remark: "",
        email: "",
        company: "",
        brandCreateReqList: [
          {
            brand: "",
            business: "",
            relation: "",
            medicineCreateReqList: [
              {
                name: "",
                specifCreateReqList: [
                  { specification: "", shortKey: "", platformIds: [] },
                ],
              },
            ],
          },
        ],
      },
      times: 0,
      code: "",
      platFormList: [],
      rules: {
        name: [{ required: true, message: "请输入申请人名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 0, max: 6, message: "长度在 0 到 6 个字符", trigger: "blur" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      subLoading: false,
      dialogVisible: false,
    };
  },
  beforeMount() {
    document.getElementById("dialogs").style.height = "150px";
  },
  mounted() {
    this.getPlatformList();

    (function (vueInstance, factory) {
      typeof exports === "object" && typeof module !== "undefined"
        ? (module.exports = factory())
        : typeof define === "function" && define.amd
        ? define(factory)
        : (window.slideVerifyPlug = factory());
      factory(vueInstance);
    })(this, function (vueInstance) {
      "use strict";

      var SlideVerify = function (ele, opt) {
        this.$ele = $(ele);
        //默认参数
        this.defaults = {
          initText: "智能校验，拖动到最右边",
          sucessText: "验证通过",
          getSuccessState: function () {},
        };
        this.settings = $.extend({}, this.defaults, opt);
        this.touchX = 0;
        this.slideFinishState = false;
        this.init();
      };
      SlideVerify.prototype = {
        constructor: SlideVerify,
        init: function () {
          var _this = this;
          _this.initDom();
          _this.initStyle();
          _this.initEle();
          _this._mousedown();
          _this._mouseup();
          _this._touchstart();
          _this._touchmove();
          _this._touchend();
        },
        initDom: function () {
          var html = $(
            '<div class="drag-progress dragProgress">' +
              "</div>" +
              '<span class="drag-btn dragBtn">' +
              "</span>" +
              '<span class="fix-tips fixTips">' +
              this.settings.initText +
              "</span>" +
              '<span class="verify-msg sucMsg">' +
              this.settings.sucessText +
              "</span>"
          );

          this.$ele.append(html);
        },
        initStyle: function () {
          if (this.settings.wrapWidth) {
            this.$ele.css({
              width: this.settings.wrapWidth,
            });
          } else {
            this.$ele.css({
              width: "100%",
            });
          }
        },
        initEle: function () {
          this.slideBtn = this.$ele.find(".dragBtn");
          this.slideProEle = this.$ele.find(".dragProgress");
          this.slideSucMsgEle = this.$ele.find(".sucMsg");
          this.slideFixTipsEle = this.$ele.find(".fixTips");
          this.maxSlideWid = this.calSlideWidth();
        },
        _mousedown: function () {
          var _this = this;
          var ifThisMousedown = false;
          _this.slideBtn.on("mousedown", function (e) {
            var distenceX = e.pageX;
            e.preventDefault();
            if (_this.slideFinishState || _this.ifAnimated()) {
              return false;
            }
            ifThisMousedown = true;
            $(document).mousemove(function (e) {
              if (!ifThisMousedown) {
                return false;
              }
              var curX = e.pageX - distenceX;

              if (curX >= _this.maxSlideWid) {
                _this.setDragBtnSty(_this.maxSlideWid);
                _this.setDragProgressSty(_this.maxSlideWid);
                _this.cancelMouseMove();
                _this.slideFinishState = true;
                _this.successSty();
                // 一秒后弹框再消失
                setTimeout(() => {
                  if (_this.settings.getSuccessState) {
                    _this.settings.getSuccessState(_this.slideFinishState);
                  }
                }, 1000);
              } else if (curX <= 0) {
                _this.setDragBtnSty("0");
                _this.setDragProgressSty("0");
              } else {
                _this.setDragBtnSty(curX);
                _this.setDragProgressSty(curX);
              }
            });
            $(document).mouseup(function () {
              if (!ifThisMousedown) {
                return false;
              }
              ifThisMousedown = false;
              if (_this.slideFinishState) {
                _this.cancelMouseMove();
                return false;
              } else {
                _this.failAnimate();
                _this.cancelMouseMove();
              }
            });
          });
        },
        _mouseup: function () {},
        _touchstart: function () {
          var _this = this;
          _this.slideBtn.on("touchstart", function (e) {
            _this.touchX = e.originalEvent.targetTouches[0].pageX;
            if (_this.slideFinishState || _this.ifAnimated()) {
              //					_this.cancelTouchmove();
              return false;
            }
          });
        },
        _touchmove: function () {
          var _this = this;
          _this.slideBtn.on("touchmove", function (e) {
            e.preventDefault();
            var curX = e.originalEvent.targetTouches[0].pageX - _this.touchX;
            if (curX >= _this.maxSlideWid) {
              _this.setDragBtnSty(_this.maxSlideWid);
              _this.setDragProgressSty(_this.maxSlideWid);
              _this.cancelTouchmove();
              _this.successSty();
              _this.slideFinishState = true;
              if (_this.settings.getSuccessState) {
                _this.settings.getSuccessState(_this.slideFinishState);
              }
              _this.slideFinishState = true;
            } else if (curX <= 0) {
              _this.setDragBtnSty("0");
              _this.setDragProgressSty("0");
            } else {
              _this.setDragBtnSty(curX);
              _this.setDragProgressSty(curX);
            }
          });
        },
        _touchend: function () {
          var _this = this;
          _this.slideBtn.on("touchend", function () {
            if (_this.slideFinishState) {
              _this.cancelTouchmove();
              return false;
            } else {
              _this.failAnimate();
            }
          });
        },
        getDragBtnWid: function () {
          //获取滑块的宽度，
          return parseInt(this.slideBtn.width());
        },
        getDragWrapWid: function () {
          //获取  本容器的的宽度，以防万一
          return parseFloat(this.$ele.outerWidth());
        },
        calSlideWidth: function () {
          var _this = this;
          return _this.getDragWrapWid() - _this.getDragBtnWid();
        },
        ifAnimated: function () {
          //判断 是否动画状态
          return this.slideBtn.is(":animated");
        },
        getDragBtnLeft: function () {
          //判断当前 按钮 离左侧的距离
          return this.slideBtn.css("left");
        },
        ifSlideRight: function () {
          var _this = this;
          if (
            parseInt(_this.getDragBtnLeft()) == parseInt(_this.calSlideWidth())
          ) {
            return true;
          } else {
            return false;
          }
        },
        setDragBtnSty: function (left) {
          this.slideBtn.css({
            left: left,
          });
        },
        setDragProgressSty: function (wid) {
          this.slideProEle.css({
            width: wid,
          });
        },
        cancelMouseMove: function () {
          $(document).off("mousemove");
        },
        cancelTouchmove: function () {
          this.slideBtn.off("touchmove");
        },
        successSty: function () {
          this.slideSucMsgEle.show();
          this.slideBtn.addClass("suc-drag-btn");
        },
        failAnimate: function () {
          this.slideBtn.animate(
            {
              left: "-1px",
            },
            200
          );
          this.slideProEle.animate(
            {
              width: 0,
            },
            200
          );
        },
        resetVerify: function () {
          this.slideSucMsgEle.hide();
          this.slideBtn.removeClass("suc-drag-btn");
          this.slideFinishState = false;
          this.slideProEle.css({
            width: 0,
          });
          this.slideBtn.css({
            left: "-1px",
          });
          this._touchmove();
        },
      };
      var inlineCss =
        "*{margin:0;padding:0;box-sizing:border-box}.verify-wrap{width:350px;height:30px;background-color:#e5e5e5;border:1px solid #e0e0e0;position:relative}.verify-wrap .drag-btn{position:absolute;left:-1px;top:-1px;width:50px;height:40px;background:#fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAiCAYAAAApkEs2AAAA/UlEQVRYhe3XLc9GYBjG8eN6dkdFIQuqoCiCbj6ob2CCIplRaJKqEHT3c/kAz66Xc/fLnvO3UY7N/jNmxDAMF77AQ57iOH53x5/GccTPuyNUcSg1DqXGodQ4lNr/CC3LEsuyaG8mrEKzLEPXdZjnWWszYRXq+z7yPMc0Tej7XnkzYf2Muq6LoiiwrivatsV1XUrby0Mlx3Huu7fvO5qmUd50kL31QgijTdXD+gq/zvNEVVXwPA9pmipvOqxDj+O4Q4IgQJIkypsuq9Bt21DXNaIoug/VzYRVqHw55J0Kw1BrMyHkXyj/3BHiUGocSo1DqXEota8Jvb/18hP16Z7qL3h/w53n4AAAAABJRU5ErkJggg==) no-repeat center center;background-size:100% 100%;z-index:2;cursor:move;}.verify-wrap .suc-drag-btn{background:#fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAiCAYAAAApkEs2AAACA0lEQVRYhe2Y2yuDYRzHv7PJYc5zKspYSRMymStXu5NCs5W4csEfwJ+gSA53csg1F4R/gSu0OcWSmNIQkfMcEvu9tdpY79793leo91Nbbft993x6nj2/52kal8v1gX+Ajp4sFstve4jidrsR99sSUlFFlUYVVRpVVGl0SnyJ934VaxczOLpdwd3bufBeWnw+StLrYc1tQ3FqnewxZIk+vz9g7rAHO9dL3z67efXBfTkrPCqymtBqGkaiNoU9FnvpSXJyzx5R8itUQ7WU4cIWnT/qhe9xS3I91VKGC0uUfpPbV4uSajUhQ1CGshxYorRxpGDObECf1Ysm40DM2a+wNhPt7mhUZzvhMI1Aq9HBkFgUUzYSrBkNtiDCkGBES/Eg8pLKwiSdplFB8uRhEzMH3RGzsSC7j9oKe1CT4wi0oEZMeRzITy4XJOM0WkFy2uOE//1O7jA8UWrm1CeJ5dMxlGXYoI/PQrd5AQlavagkZTmwlt4UOHGCnPs9wkw+vl0jSZcWdSZDsz8uas1tD3t99rSL8b0W3Lz4cHy/LrrctYEjlQNr6Y2ptag0NIf10gv/Pvo3akRzlOGe++yTyV4yhAJ9leR6qqUMF7YoXTC6zPPChSMaVEO1ci4lstoTDdxROhE4Fjv/9jUvCIkoISPGv7nhq6JKo4oqjSqqNEIfpf8f/zqf+36643RPeo8AAAAASUVORK5CYII=) no-repeat center center;background-size:100% 100%}.verify-wrap .drag-progress{position:absolute;left:0;top:-1px;height:40px;border-top:1px solid #7ac23c;border-top:1px solid #7ac23c;width:0;background-color:#7ac23c;color:#fff;font-size:18px;text-align:center;line-height:40px}.verify-wrap .fix-tips,.verify-msg{width:100%;position:absolute;right:0;left:1px;height:100%;color:#51555c;z-index:1;line-height:38px;font-size:12px;text-align:center}.verify-wrap .verify-msg{background-color:#7ac23c;color:#fff;display:none}";
      var styleObj = $('<style type="text/css">' + inlineCss + "</style>");
      $("head").prepend(styleObj);

      var slideVerify = window.slideVerifyPlug || SlideVerify;
      var that = vueInstance;
      new slideVerify("#verify-wrap", {
        wrapWidth: "340", //设置 容器的宽度 ,不设置的话，会设置成100%，需要自己在外层包层div,设置宽度，这是为了适应方便点；
        getSuccessState: function (res) {
          that.times = 60;
          let w = setInterval(() => {
            that.times--;
            if (!that.times) {
              clearInterval(w);
            }
          }, 1000);
          // var hashedString = md5('通过');
          axios
            .post(BASEURL + "/admin-api/system/auth/send-sms-code", {
              mobile: that.formInline.mobile,
              scene: "22",
            })
            .then((response) => this.$message.success("发送成功！"));
        },
      });

      // return slideVerify;
    });
  },
  methods: {
    handleBlankClick(event) {
      console.log(event.target);
    },
    isElementToExclude(element) {
      // 在这里添加你的逻辑来确定哪些元素应该被排除
      // 例如，你可以检查元素的类名或 ID
      // 这是一个简单的示例，只排除具有特定类名的元素
      return element.classList.contains("exclude-class");
    },
    getyzm() {
      this.$refs["formInline"].validateField("mobile", (valid) => {
        console.log(valid);
        if (valid == "请输入电话号码" || valid == "手机号格式不正确") {
        } else {
          this.dialogVisible = true;
        }
      });
    },
    back() {
      window.location.href = "index.html";
    },
    getPlatformList() {
      axios
        .get(BASEURL + "/admin-api/drug/platform/list-all-simple")
        .then((res) => {
          this.platFormList = res.data.data;
        });
    },

    submited() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          this.subLoading = true;
          axios
            .post(BASEURL + "/admin-api/website/submit", this.formInline)
            .then((res) => {
              if (res.data.code === 0) {
                this.$message.success("提交成功！客服人员稍后将与您联系！");
                this.subLoading = false;
                setTimeout(() => {
                  window.location.href("index.html");
                }, 2000);
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((e) => this.$message.error(e.msg));
        }
      });
    },

    addpp() {
      this.formInline.brandCreateReqList.push({
        brand: "",
        business: "",
        relation: "",
        medicineCreateReqList: [
          {
            name: "",
            specifCreateReqList: [
              { specification: "", shortKey: "", platformIds: [] },
            ],
          },
        ],
      });
    },

    deletepp(index) {
      this.formInline.brandCreateReqList.splice(index, 1);
    },
    addyp(index, num) {
      this.formInline.brandCreateReqList[index].medicineCreateReqList.push({
        name: "",
        specifCreateReqList: [
          { specification: "", shortKey: "", platformIds: [] },
        ],
      });
    },
    deleteyp(index, num) {
      this.formInline.brandCreateReqList[index].medicineCreateReqList.splice(
        num,
        1
      );
    },
    addgg(index, num) {
      this.formInline.brandCreateReqList[index].medicineCreateReqList[
        num
      ].specifCreateReqList.push({
        specification: "",
        shortKey: "",
        platformIds: [],
      });
    },
    deletegg(index, num, i) {
      this.formInline.brandCreateReqList[index].medicineCreateReqList[
        num
      ].specifCreateReqList.splice(i, 1);
    },
  },
});



// WEBPACK FOOTER //
// ./src/view/apply/index.js